export const TOGGLE_ONE_CLICK_MODE = 'TOGGLE_ONE_CLICK_MODE';
export const SET_ONE_CLICK_AMOUNT = 'SET_ONE_CLICK_AMOUNT';
export const SET_ACCEPT_FACTOR_CHANGE_MODE = 'SET_ACCEPT_FACTOR_CHANGE_MODE';
export const TOGGLE_ACCEPT_FACTOR_INCREASE = 'TOGGLE_ACCEPT_FACTOR_INCREASE';
export const TOGGLE_ACCEPT_FACTOR_DECREASE = 'TOGGLE_ACCEPT_FACTOR_DECREASE';
export const SET_FAVOURITE_BET_AMOUNT = 'SET_FAVOURITE_BET_AMOUNT';



// WEBPACK FOOTER //
// ./js/actions/BettingMode.js